import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/publishSegment';
import { fetchRequest as fetchGoalDetail } from '../../actions/discovery/goalDetail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId } = action?.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/publish-segment`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    // Refresh the goal so published_segment_id lands in the detail view.
    yield put(fetchGoalDetail({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
